import { render, staticRenderFns } from "./Prakerja.vue?vue&type=template&id=4a5ab5d1&scoped=true"
import script from "./Prakerja.vue?vue&type=script&lang=js"
export * from "./Prakerja.vue?vue&type=script&lang=js"
import style0 from "./prakerja.css?vue&type=style&index=0&id=4a5ab5d1&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5ab5d1",
  null
  
)

export default component.exports